import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/router/routes/index.js'
import store from '../store';

Vue.use(VueRouter);


const router = new VueRouter({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/' : '/',
    routes
  })

router.beforeEach((to, from, next) => {

    const authenticated = store.getters.user.loggedIn
    const isPublic = to.matched.some(record => record.meta.public)
    const isApp = to.matched.some(record => record.meta.app)

    console.log('authenticated:' + authenticated)
    console.log('isPublic:' + isPublic)
    console.log('isApp:' + isApp)

    console.log(to.path)
    if(to.path.toString().toLowerCase().includes('admin') > 0){
        if (isPublic && !authenticated) {
            console.log('ok-1')
            if(to.path == '/admin/login'){
                console.log('ok-2')
                store.commit('setLayout', 'auth');
                next()
             }else if(to.path == '/admin/recuperarcuenta'){
                console.log('ok-2.1')
                store.commit('setLayout', 'auth');
                next()
            }else if(to.path == '/admin/reiniciarclave'){
                console.log('ok-2.2')
                store.commit('setLayout', 'auth');
                next()
             }else{
                console.log('ok-3')
                store.commit('setLayout', 'auth');
                next('/admin/login')
             }
        }else if (!isPublic && !authenticated) {
            console.log('ok-4')        
            if(to.path == '/admin/login'){
                console.log('ok-5')
                store.commit('setLayout', 'auth');
                next()
            }else{
                console.log('ok-6')
                store.commit('setLayout', 'auth');                
                next('/admin/login')
            } 
        }else  if (authenticated && isApp) {
            if(to.path == '/admin' || to.path == '/admin/'){
                console.log('ok-7')
                store.commit('setLayout', 'app');
                next('/admin/dashboard');
            }else{
                console.log('ok-7.1')
                store.commit('setLayout', 'app');                
                next()
            }
           
        }
    }else{
        console.log('ok-8')
        store.commit('setLayout', 'auth');
        next()
    }
    
    
});

export default router;
